import React, { render, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

import App from "./App"; // eslint-disable-line @typescript-eslint/no-unused-vars

function init() {
  //const el = document.getElementById("factset-widget");
  const widgets = document.getElementsByClassName("factset-widget");

  for (let i = 0; i < widgets.length; i++) {
    const id = widgets[i].id;
    const el = document.getElementById(id);

    if (el) {
      const { investmentId, publicationDate, includeEsg, widgetType } = el.dataset;
      console.log(investmentId);
      if (investmentId) {
        render(
          <App
            investmentId={investmentId}
            publicationDate={publicationDate}
            includeEsg={includeEsg}
            widgetType={widgetType}
            instanceId={id}
          />,
          el
        );
      }
    }
  }
}

export default { init };
